import React from "react";
import styles from "./ChapterHeading.module.less";

export interface Props {
    heading: string;
    preHeading?: string;
}

function ChapterHeading(props: Props) {
    return (
        <div className={styles.ChapterHeading}>
            {props.preHeading ? <span className={styles["ChapterHeading-preHeading"]}>{props.preHeading}</span> : null}
            <h2 className={styles["ChapterHeading-heading"]}>{props.heading}</h2>
        </div>
    );
}

export default ChapterHeading;
